
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getAllTodos, getAllUserWithoutPagination } from "../../../store/actions/user.action";
import { getApiEndPoint } from "../../../utils/GenerateQueryString";
import { ColumnDef } from "@tanstack/react-table";
import { Divider, Text } from "theme-ui";
import queryString from "query-string";
import { TabelHeadingTxt } from "../../Text/TabelCommonTxt";
import DataTable from "../../Tabels/Tabel";
import { toConvertLocalDateFormat } from "../../../utils/CustomHandler";
const CompletedTodo: React.FC = () => {
    const { todos, loader, userData } = useSelector((state: any) => state.user);
    const { paginations } = useSelector((state: any) => state.pagination);
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams({
        currentPage: "1",
        limit: "15",
    });
    const limit = parseInt(searchParams.get('limit') || "15");
    const currentPage = parseInt(searchParams.get('currentPage') || "1");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState<boolean>(true);
    const [checkedTodos, setCheckedTodos] = useState<{ [key: string]: boolean }>({});
    const [dueDates, setDueDates] = useState<{ [key: string]: Date | null }>({});

    useEffect(() => {
        dispatch(getAllUserWithoutPagination())
    }, [dispatch])

    useEffect(() => {
        let apiEndPoint = getApiEndPoint({ limit, currentPage }, location.search, columns?.map((val: any) => ({ accessorKey: val.accessorKey, filterType: val.filterType })) || [], location?.pathname
        )
        dispatch(getAllTodos(apiEndPoint))
        setRefresh(false);
    }, [refresh, location?.search, limit, currentPage])

    useEffect(() => {
        if (todos?.data) {
            const initialCheckedState = todos?.data?.reduce((acc: any, todo: any) => {
                acc[todo._id] = todo.isCompelted;
                return acc;
            }, {});
            setCheckedTodos(initialCheckedState);

            const initialDueDates = todos?.data.reduce((acc: any, todo: any) => {
                acc[todo._id] = todo.todoDueDate?.split('T')[0] || '';
                return acc;
            }, {});
            setDueDates(initialDueDates);

        }
    }, [todos?.data]);
    const today = new Date().toISOString().split('T')[0];
    const columns = useMemo<ColumnDef<any>[]>(() => [
        {
            header: 'No',
            enableColumnFilter: false,
            accessorKey: "no",
            cell: ({ row }) => {
                return (
                    <Text variant='Poppins14Normal24lh'>{((currentPage - 1) * limit) + row?.index + 1}</Text>
                )
            },
        },
        {
            accessorKey: "todoName",
            header: 'Todo Name',
            cell: info => info.getValue(),
            enableColumnFilter: true,
            filterType: "textbox",

        },

        {
            header: 'Todo Assignee',
            accessorKey: "todoAssignee",
            cell: ({ row }) => {
                const todoMembers = row.original.todoAssignee;
                return (
                    <Text >
                        {todoMembers?.FirstName} {todoMembers?.LastName}
                    </Text>
                );
            },
            filterType: 'dropdown',
            options: userData?.data?.map((val: { _id: string, FirstName: string, LastName: string }) => ({ value: val._id, label: `${val.FirstName} ${val.LastName}` }))
        },

        {
            header: 'Todo  Checklist',
            accessorKey: "todoChecklistCount",
            cell: info => info.getValue(),
        },
        {
            header: 'Is Completed',
            accessorKey: 'isCompelted',
            cell: ({ row }) => {
                const todoId = row?.original?._id;
                return (
                    <input
                        type="checkbox"
                        // disabled
                        checked={checkedTodos[todoId] ?? false}
                        // onChange={() => handleCheckboxChange(todoId, !checkedTodos[todoId])}
                        style={{ opacity: 0.7, cursor: "not-allowed" }}
                    />
                );
            },
        },
        {
            header: 'Due Date',
            accessorKey: 'todoDueDate',
            cell: ({ row }) => {
                const { todoDueDate } = row.original;

                return (
                    <Text variant='Poppins14Normal24lh'>{toConvertLocalDateFormat(todoDueDate) || '-'}</Text>
                    // <div style={{ position: 'relative' }}>
                    //     <Input
                    //         type="date"
                    //         // label="Due Date"
                    //         onBlur={() => { }}
                    //         name={`todoDueDate`}
                    //         onChange={(event: any) => {
                    //             const newDate = event.target.value;
                    //             handleDueDateChange(row.original._id, newDate);
                    //         }}
                    //         value={todoDueDate?.split('T')[0] || ''}
                    //         placeholder=""
                    //         disabled
                    //         sx={{
                    //             borderColor: isDueDatePassed ? 'red' : '#F7EFE5',
                    //             borderWidth: isDueDatePassed ? '2px' : '1px',
                    //             borderStyle: 'solid',
                    //             borderRadius: '12px',
                    //             color: isDueDatePassed ? 'red' : 'black'

                    //         }}
                    //     />

                    // </div>
                );
            },
        },
        // {
        //     header: 'Accessor',
        //     accessorKey: "Accessor",
        //     enableColumnFilter: false,
        //     cell: ({ row }) => {
        //         return (
        //             <TableActions row={row} editTo={`/edit-todo/${row?.original?._id}`} deleteMessage='Are you sure you want to delete this todo?' deleteApi={`todo/delete-todo/${row?.original?._id}`} toggleRefresh={() => setRefresh(true)} />
        //         )
        //     },
        // }
    ], [todos?.data, checkedTodos, dueDates]);

    // const handleCheckboxChange = (todoId: string, isChecked: boolean) => {

    //     const payload = {
    //         isCompleted: isChecked,
    //     };
    //     dispatch(ActionUpdateById({ Query: `/todo/edit-Todo/${todoId}`, obj: payload },
    //         (res: any) => {
    //             if (res.status === 200) {
    //                 setCheckedTodos(prev => ({
    //                     ...prev,
    //                     [todoId]: isChecked,
    //                 }));

    //             }
    //             setRefresh(true);

    //         }
    //     ));

    // };
    return (
        <div className='main-content'>
            <TabelHeadingTxt Title='Completed Todos' Count={todos?.count} IsExportButtonShow={false} sx={{ backgroundColor: '#7743DB', color: 'white' }} />
            <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
            <DataTable
                loader={loader}
                columns={columns}
                data={todos?.data || []}
                TotalLength={todos?.count || 15}
                perPageCount={limit || 15}
                currentPage={paginations.currentPage}
                onPerPageChange={(itemsPerPage) => {
                    if (searchParams?.size > 2) {
                        const parsedQuery = queryString.parse(location.search);

                        setSearchParams({
                            ...parsedQuery,
                            limit: itemsPerPage.toString(),
                        });
                    } else if (todos?.count < itemsPerPage) {
                        setSearchParams({
                            currentPage: '1',
                            limit: itemsPerPage.toString(),
                        });
                    }
                    else {
                        setSearchParams({
                            currentPage: currentPage.toString(),
                            limit: itemsPerPage.toString(),
                        });
                    }

                }}
                onPageChange={(value: string) => {
                    console.log(value, "onPageChange");

                    if (searchParams?.size > 2) {
                        const parsedQuery = queryString.parse(location.search);

                        setSearchParams({
                            ...parsedQuery,
                            currentPage: value.toString(),
                        });
                    } else {
                        setSearchParams({
                            currentPage: value.toString(),
                            limit: limit.toString(),
                        });
                    }

                }}

            />
        </div>
    )
}

export default CompletedTodo